// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__2NB1i","submitLoading":"style_submitLoading__RhbIq","submitLoading--dark":"style_submitLoading--dark__2ycgy"};